import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, DollarSign, Users, TrendingUp } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function Omnicredit() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-422" data-mp="6zm0bevjwujt">
      <div className="max-w-6xl mx-auto px-4" data-id="element-423" data-mp="6xrhq77r5eiw">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-424" data-mp="3ofamjj0o58ti">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-425" data-mp="3fg73ug5eyvfj" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-426" data-mp="3kfa8w0le91ni">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-427" data-mp="3kc4hgepalnom">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-428" data-mp="35ij6rjkc5bu7">
              Financial Services
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-429" data-mp="12ja6cmpqd786">
              Lead Gen
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-430" data-mp="1bkrrwklwq149">
              Paid Social
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-431" data-mp="jvor5et8b8wd">
            Omnicredit
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-432" data-mp="etplfya0nzw9">
            From Zero to $40K/Month in 4 Months
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-433" data-mp="nudyoqrl5w83">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-434" data-mp="64mmgk6cmu5">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-435" data-mp="49xsr5s8aks">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-436" data-mp="1v99jx3kz89i0">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-437" data-mp="2072o5r2pytfn" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-438" data-mp="250e0u8u7q4fh">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-439" data-mp="29xdwrqxclqsv">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-440" data-mp="1cdb3vl56q1rc" />
                </div>
                <div data-id="element-441" data-mp="1hc49ysi56qhh">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-442" data-mp="1m9e5mpw4jydr">
                    $40K
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-443" data-mp="1r9seub9gpedd">
                    Monthly Revenue
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-444" data-mp="32ph3d72d6lga">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-445" data-mp="m2929zpfolvm">
                <Users className="w-24 h-24 text-engage-yellow" data-id="element-446" data-mp="h8mzr0czhydj" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-447" data-mp="cabocl71jft7">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-448" data-mp="7ca4vz5pdeh7">
                  <Users className="w-6 h-6 text-engage-yellow" data-id="element-449" data-mp="3956a7oqtwxu" />
                </div>
                <div data-id="element-450" data-mp="3uh9jfyn4ya4k">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-451" data-mp="3uiu50yrh2iqa">
                    0 to 100+
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-452" data-mp="1sobj7hr14f9l">
                    Daily Leads
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-453" data-mp="lddkj8g52run">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-454" data-mp="bfhakjyxu2y4">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-455" data-mp="gcpwmvn7ir4n" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-456" data-mp="1omlz8y7yr9i">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-457" data-mp="6g4pa3npt3xn">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-458" data-mp="3ouvublfh28xp" />
                </div>
                <div data-id="element-459" data-mp="3ttgszgf2skk1">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-460" data-mp="3tsx8bry1ji2b">
                    4x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-461" data-mp="3jv131grsbhc4">
                    ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-462" data-mp="2w9gwy1qkts1w">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-463" data-mp="3a8gi2zevrotb">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-464" data-mp="3567qo7hnoutb">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-465" data-mp="3j57exe19b7oy" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-466" data-mp="3f5q6qcug3wg3">
              OmniCredit entered the market with no existing growth
              infrastructure{'\u2014'}no revenue history, no validated digital
              acquisition system, and no funnel in place to consistently
              generate or convert demand. Like many early-stage financial
              brands, the challenge wasn{'\u2019'}t just attracting attention,
              but doing so with enough clarity, trust, and precision to bring
              qualified leads into the business. The goal was not simply to
              launch fast, but to build the right system from day one.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-467" data-mp="njodgrxjj1yr">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-468" data-mp="nkzmb65uezwq">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-469" data-mp="wjbjjr17svy5" />
              <div className="relative z-10" data-id="element-470" data-mp="11jquyd1xrtdh">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-471" data-mp="16hsgd4mu44s4">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-472" data-mp="33bm0eaxln1n9" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-473" data-mp="388m0m57rpa6g">
                  We developed a full marketing strategy, defining the avatar,
                  positioning, and overall plan. From there, we created
                  high-performing content aligned with that strategy, launched
                  Meta ads, and implemented a proven funnel system optimized for
                  conversion.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-474" data-mp="3jpa5uie0zopm">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-475" data-mp="3eqp58huv330n" />
              <div className="relative z-10" data-id="element-476" data-mp="39sdve74kgsif">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-477" data-mp="34qg54sxr0xfz">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-478" data-mp="1y9b25wfj304w" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-479" data-mp="1targzy8rdsdl">
                  Within the first month, results came in almost
                  immediately—high-quality leads started flowing in and deals
                  began closing consistently. In just 90 days, Omnicredit scaled
                  from $0 to $40K/month in revenue, powered by the Engage
                  Machine and a system built to generate and convert demand.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-480" data-mp="36qkir0d7rvnb">
            <div className="flex justify-center mb-8" data-id="element-481" data-mp="2sydz34aur6j4">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-482" data-mp="2wzpvpts58s0t">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-483" data-mp="3pid90n0wf2rc" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-484" data-mp="v37h4ky4jtzb">
              We didn{'\u2019'}t just launch{'\u2014'}we built a system that
              generates revenue consistently. From zero to a real acquisition
              engine in months.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-485" data-mp="2gepbyie5jybk">
              <img src="https://cdn.magicpatterns.com/uploads/dPAfToJ51mhUvjXGJW51v5/Omnicredit-CS.png" alt="Omnicredit" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-486" data-mp="2bhgxosw4kefl" />
              <div className="font-bold text-engage-white text-lg" data-id="element-487" data-mp="3sjxx4dq9odrv">
                OmniCredit Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-488" data-mp="3nlwdnroxicfv">
                CEO, OmniCredit
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-489" data-mp="3ejdhfqfney2l">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-490" data-mp="39ng0bhwk9nor" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-491" data-mp="17tqdugsqz7g6">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-492" data-mp="17t74vpl2rtea">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-493" data-mp="1aey6vwv7pkxg">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-494" data-mp="1k3ofvsoo695y">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}